import httpServe from './httpServe';
let recruitService = {};

//  查询学期
recruitService.queryTerm = async function (param) {
    let url = httpServe.getTeamUrl('/api/term/queryTerm');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
}

//  查询班级
recruitService.queryClass = async function (param) {
    let url = httpServe.getTeamUrl('/api/class/queryClass');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
}


export default recruitService;



// WEBPACK FOOTER //
// ./src/utils/recruit.js